import { apiClient } from "./client";

/** Chiavi dei quattro moduli aggregati dal riepilogo. */
export type ModuloKey = "installazioni" | "sopralluoghi" | "interventi" | "attivazioni";

export interface AndamentoModulo {
  totale: number;
  /** { "<stato>": n }. Lo stato null (interventi da Odoo) arriva come "Senza stato". */
  per_stato: Record<string, number>;
  /** Ultimi 12 mesi fino a quello corrente, sempre completi (anche a zero). */
  serie: { mese: string; n: number }[];
  mese_corrente: number;
  mese_precedente: number;
  delta: number;
  /** Record senza data di dominio: contano nel totale, non nella serie. */
  senza_data: number;
  /** Record con data oltre il mese corrente (es. installazioni già programmate). */
  futuri: number;
  futuri_per_mese: { mese: string; n: number }[];
}

export type RiepilogoModuli = Record<ModuloKey, AndamentoModulo>;

/**
 * Riepilogo aggregato dei quattro moduli (conteggi, distribuzione per stato,
 * andamento mensile). Scopizzato lato server: admin/staff vedono tutto, CA il
 * proprio centro, e così via.
 */
export async function getRiepilogo(): Promise<RiepilogoModuli> {
  const { data } = await apiClient.get<{ moduli: RiepilogoModuli }>("/dashboard/riepilogo");
  return data.moduli;
}
